/* ==========================================================================
   WSH DAW-Ready Sessions — UI state management
   Handles DAW pill switching, state toggle, callout rendering, browse link.
   ========================================================================== */

(function () {
  'use strict';

  function init() {
    var section = document.querySelector('[data-wsh-section="daw-ready-sessions"]');
    if (!section) return;
    if (section.dataset.wshInit === 'true') return;
    section.dataset.wshInit = 'true';

    var heroRegion = section.querySelector('.wsh-daw-rs__hero-region');
    var pills = section.querySelectorAll('.wsh-daw-rs__pill');
    var stateBtns = section.querySelectorAll('.wsh-daw-rs__state-btn');
    var browseLink = section.querySelector('[data-browse-link]');
    var mobileBadgeStack = section.querySelector('[data-mobile-badge]');

    var activeDaw = null;
    var activeState = 'arrangement';

    // Parse and render callouts for all hero panels on init
    var heroes = heroRegion.querySelectorAll('.wsh-daw-rs__hero');
    heroes.forEach(function (hero) {
      var dataEl = hero.querySelector('.wsh-daw-rs__callouts-data');
      if (!dataEl) return;
      var raw = dataEl.getAttribute('data-callouts');
      if (!raw) return;

      try {
        var callouts = JSON.parse(raw);
        var container = hero.querySelector('.wsh-daw-rs__callouts-desktop');
        if (!container) return;

        callouts.forEach(function (c) {
          var el = document.createElement('div');
          el.className = 'wsh-daw-rs__callout';
          el.setAttribute('data-position', c.position);
          el.textContent = c.text;
          container.appendChild(el);
        });
      } catch (e) {
        // Silently skip unparseable callouts
      }
    });

    // Determine initial active DAW from the first active pill
    var firstActivePill = section.querySelector('.wsh-daw-rs__pill--active');
    if (firstActivePill) {
      activeDaw = firstActivePill.getAttribute('data-daw');
    }

    function setActiveHero() {
      heroes.forEach(function (hero) {
        var match = hero.getAttribute('data-daw') === activeDaw &&
                    hero.getAttribute('data-state') === activeState;
        hero.classList.toggle('wsh-daw-rs__hero--active', match);
        hero.setAttribute('aria-hidden', match ? 'false' : 'true');
      });

    }

    function updateMobileBadge() {
      if (!mobileBadgeStack) return;
      var activePill = section.querySelector('.wsh-daw-rs__pill--active');
      if (!activePill) return;
      var label = activePill.getAttribute('data-daw-label');
      var actionLine = activePill.getAttribute('data-action-line') || '';
      var badge = mobileBadgeStack.querySelector('.wsh-daw-rs__mobile-badge');
      var action = mobileBadgeStack.querySelector('.wsh-daw-rs__mobile-action');
      if (badge) badge.textContent = 'DAW-Ready Session \u00B7 ' + label;
      if (action) action.textContent = actionLine;
    }

    function updateBrowseLink() {
      if (!browseLink) return;
      var activePill = section.querySelector('.wsh-daw-rs__pill--active');
      if (!activePill) return;
      var label = activePill.getAttribute('data-daw-label');
      var collHandle = activePill.getAttribute('data-collection-handle');
      browseLink.href = '/collections/' + (collHandle || 'all');
      browseLink.textContent = 'Browse all ' + label + ' sample packs \u2192';
    }

    // DAW pill click
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) {
          p.classList.remove('wsh-daw-rs__pill--active');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('wsh-daw-rs__pill--active');
        pill.setAttribute('aria-pressed', 'true');

        activeDaw = pill.getAttribute('data-daw');
        activeState = 'arrangement';

        // Reset state toggle to Arrangement
        stateBtns.forEach(function (btn) {
          var isArr = btn.getAttribute('data-state') === 'arrangement';
          btn.classList.toggle('wsh-daw-rs__state-btn--active', isArr);
          btn.setAttribute('aria-pressed', isArr ? 'true' : 'false');
        });

        setActiveHero();
        updateBrowseLink();
        updateMobileBadge();
      });
    });

    // State toggle click
    stateBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        stateBtns.forEach(function (b) {
          b.classList.remove('wsh-daw-rs__state-btn--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('wsh-daw-rs__state-btn--active');
        btn.setAttribute('aria-pressed', 'true');

        activeState = btn.getAttribute('data-state');
        setActiveHero();
      });
    });

    // Preload-on-hover: when hovering an inactive pill, preload that DAW's arrangement image
    pills.forEach(function (pill) {
      pill.addEventListener('mouseenter', function () {
        var dawHandle = pill.getAttribute('data-daw');
        if (dawHandle === activeDaw) return;
        var target = heroRegion.querySelector(
          '.wsh-daw-rs__hero[data-daw="' + dawHandle + '"][data-state="arrangement"] img'
        );
        if (target && target.loading === 'lazy') {
          target.loading = 'eager';
        }
      });
    });

    // Initial callout render for mobile
    setActiveHero();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run on section re-render (Shopify theme editor)
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('[data-wsh-section="daw-ready-sessions"]')) {
      var section = e.target.querySelector('[data-wsh-section="daw-ready-sessions"]');
      if (section) section.dataset.wshInit = '';
      init();
    }
  });
})();
